/* Scroll build-up v3 (v50).
   v2 had a "show everything after 12 seconds" safety net. Almost every
   visitor spends longer than that on the offer before scrolling, so by the
   time they scrolled nothing was left to animate. Gone.
   How it works now:
   - Only pieces BELOW the fold are ever hidden (titles, text, photos, cards,
     buttons), never whole sections, and never the offer.
   - A piece appears the moment its top passes 92% of the screen. Checked on
     scroll AND every 400ms, so a missed scroll event cannot leave it hidden.
   - Anything above the viewport is always shown at once (fast scrolls, jumps).
   - Hiding only applies while html has .ifa-ready, which this script sets; if
     it fails to run, everything is visible. */
(function(){
if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var root=null,pend=[];
var css=document.createElement('style');
css.textContent='html.ifa-ready #if .ifa{opacity:0;transform:translateY(28px);transition:opacity .65s ease,transform .8s cubic-bezier(.2,.8,.2,1)}'+
'html.ifa-ready #if img.ifa{transform:translateY(16px) scale(1.04)}'+
'html.ifa-ready #if .ifa.ifa-in{opacity:1!important;transform:none!important}';
document.head.appendChild(css);
var SKIP='#shop,header,#if-shipbar,#if-sg,#if-sticky,#if-add,#if-bundles,#if-units,#if-thumbs,[id^=if-cd],[id^=if-dm],script,style';
var PIECES='h2,h3,p,img,video,blockquote,a[href="#shop"],button,[style*="grid"] > *,[style*="flex-wrap"] > *,#if-reviews > *,#if-faqs > *,[data-if-face],[data-if-reel]';
function mark(){root=root||document.getElementById('if');if(!root)return;var vh=window.innerHeight;
[].forEach.call(root.querySelectorAll(PIECES),function(el){
if(el.dataset.ifa)return;el.dataset.ifa='1';
if(el.closest(SKIP))return;
if(el.parentElement&&el.parentElement.closest('.ifa'))return;
if(el.offsetParent===null)return;
var s=getComputedStyle(el);if(s.position==='fixed'||s.position==='sticky')return;
var r=el.getBoundingClientRect();
if(r.height>vh*0.9)return;
if(r.top<vh*0.95)return;
el.classList.add('ifa');pend.push(el);});
}
var raf=0;
function check(){raf=0;var vh=window.innerHeight,n=0,keep=[];
for(var i=0;i<pend.length;i++){var el=pend[i];if(!el.isConnected)continue;var r=el.getBoundingClientRect();
if(r.top<vh*0.92||r.bottom<0){el.style.transitionDelay=Math.min(n,6)*70+'ms';el.classList.add('ifa-in');n++;}else keep.push(el);}
pend=keep;}
function onScroll(){if(!raf)raf=requestAnimationFrame(check);}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('touchmove',onScroll,{passive:true});
window.addEventListener('resize',onScroll,{passive:true});
function boot(){document.documentElement.classList.add('ifa-ready');mark();check();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
var k=0;var iv=setInterval(function(){k++;mark();check();if(k>30)clearInterval(iv);},400);
setInterval(check,400);
[].forEach.call(document.querySelectorAll('#if .ifr,#if .ifr-k,#if .ifr-h'),function(e){e.classList.remove('ifr','ifr-k','ifr-h')});
})();
